import { render } from "./NFDownload.vue?vue&type=template&id=5fc45eca&scoped=true"
import script from "./NFDownload.vue?vue&type=script&lang=js"
export * from "./NFDownload.vue?vue&type=script&lang=js"

import "./NFDownload.vue?vue&type=style&index=0&id=5fc45eca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fc45eca"]])

export default __exports__